import styled from 'styled-components/macro';
import Select from 'react-select';
import { getSelectAnimation } from 'styles/animations.styled';

export const Wrapper = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
`;

export const StyledSelectAddress = styled(Select)<{
  fulfilled: boolean;
  collapsed: boolean;
  noTenant?: boolean;
}>`
  width: ${(props) => (props.noTenant ? '100%' : '75%')};

  .address__control {
    border: 1px solid ${(props) => (props.fulfilled ? '#697180' : '#ced5de')};
    animation-name: ${(props) => getSelectAnimation(props.collapsed)};
    animation-delay: 0s;
    animation-duration: 300ms;
    transition: 150ms all;
  }
`;

export const StyledSelectArea = styled(Select)<{
  fulfilled: boolean;
  collapsed: boolean;
}>`
  width: 25%;

  .area__control {
    border: 1px solid ${(props) => (props.fulfilled ? '#697180' : '#ced5de')};
    animation-name: ${(props) => getSelectAnimation(props.collapsed)};
    animation-delay: 0s;
    animation-duration: 300ms;
    transition: 150ms all;
  }
`;
